import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import './App.css'
import PrivateRoute from "./PrivateRaoute";
import SplashScreen from './components/Login/SplashScreen';
import SignUp from "./components/Login/SignUp";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import LoginFlow from "./Pages/Login/LoginFlow";
import { fetchProfile } from "./Api/Login";
import { loginAction } from "./ReduxStore/login";
import SuperCategory from "./components/Login/SuperCategory";

function App() {
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  const [showTrialModal, setShowTrialModal] = useState(false);

  const login = useSelector((state) => state.login.login);
  const token = useSelector((state) => state.login.token);
  const userProfile = useSelector((state) => state.login.userProfile);

  const dispatch = useDispatch()

  useEffect(() => {

     
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setShowSplashScreen(false);
      }, 1000);
    }, 3000);

    const profile = async () => {
      if (token) {
        const profile = await fetchProfile(token)
        dispatch(loginAction.userProfile(profile.data))
        handleLoginSuccess()
      }
    }
    profile();
   
    return () => clearTimeout(timer);
  }, [token]);

  const handleLoginSuccess = () => {
    setShowTrialModal(true);
  };
  
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            !login ? (
              showSplashScreen ? (
                <SplashScreen fadeOut={fadeOut} />
              ) : (
                <LoginFlow />
              )
            ) : (
              showSplashScreen ? (
                <SplashScreen fadeOut={fadeOut} />
              ) : login && userProfile.newUser ? (
                <SignUp />
              ) : (
                <Navigate to="/dashboard" />
              )
            )
          }
          
        />
     
        

        {PrivateRoute.map((route, index) => {
          const { path, element, private: isPrivate } = route;
          return (
            <Route
              key={index}
              path={path}
              element={
                isPrivate ? ((login && !userProfile.newUser) ? element : <Navigate to="/" />) : element
              }
            />
          );
        })}
      </Routes>
      
        <ToastContainer />
    </>
  )
};


export default App;
